// extracted by mini-css-extract-plugin
export default {"dropdown":"lWuSO","suffix":"fdGb3","active":"IEf5s","list":"VLdcQ","list-l":"SK7My","list-s":"SjPQI"};